module.exports = __webpack_public_path__ + "img/banner-before.097fd831.webp";